import { Label } from "@/components/ui/label";

/**
 * MessagingDialog Sub-Component (extracted 2026-07 refactor).
 *
 * Toggle zwischen "Standardschreiben" und "Vorgangsbezogen" + Vorgang-Auswahl.
 * Sichtbar in der Sidebar. Rein präsentational — State lebt weiter im Parent.
 */
export default function LetterModeToggle({
  letterMode, setLetterMode,
  vorgangId, setVorgangId,
  vorgaenge,
}) {
  return (
    <div>
      <Label className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Schreibensart</Label>
      <div className="mt-1 grid grid-cols-2 gap-1 rounded-md border border-slate-200 bg-white p-0.5" data-testid="msg-mode-toggle">
        <button
          type="button"
          onClick={() => { setLetterMode("standard"); setVorgangId(""); }}
          className={`text-xs py-1.5 rounded transition-colors ${letterMode === "standard" ? "bg-slate-900 text-white font-semibold" : "text-slate-600 hover:bg-slate-100"}`}
          data-testid="msg-mode-standard"
        >Standardschreiben</button>
        <button
          type="button"
          onClick={() => setLetterMode("vorgang")}
          className={`text-xs py-1.5 rounded transition-colors ${letterMode === "vorgang" ? "bg-slate-900 text-white font-semibold" : "text-slate-600 hover:bg-slate-100"}`}
          data-testid="msg-mode-vorgang"
          disabled={vorgaenge.length === 0}
          title={vorgaenge.length === 0 ? "Keine offenen Vorgänge im Kontext" : ""}
        >Vorgangsbezogen</button>
      </div>
      {letterMode === "vorgang" && (
        <div className="mt-2 space-y-2 rounded-md border border-amber-200 bg-amber-50/70 p-2" data-testid="msg-vorgang-block">
          <div className="text-[10px] uppercase tracking-wider text-amber-800 font-semibold">Vorgang wählen</div>
          <select
            value={vorgangId}
            onChange={(e) => setVorgangId(e.target.value)}
            className="h-8 text-xs border border-amber-200 rounded-md px-2 bg-white w-full focus:outline-none focus:border-amber-400"
            data-testid="msg-vorgang-select"
          >
            <option value="">— Vorgang wählen —</option>
            {vorgaenge.map((v) => (
              <option key={v.id} value={v.id}>
                {v.case_number} · {v.title.slice(0, 40)}{v.title.length > 40 ? "…" : ""}
              </option>
            ))}
          </select>
          {vorgangId && (() => {
            const vg = vorgaenge.find((x) => x.id === vorgangId);
            if (!vg) return null;
            return (
              <div className="text-[10px] text-amber-900 space-y-0.5" data-testid="msg-vorgang-info">
                <div><strong>Unser Zeichen:</strong> <span className="font-mono">{vg.unser_zeichen || "—"}</span></div>
                <div><strong>Status:</strong> {vg.status}</div>
                <div className="text-amber-700 italic mt-1">
                  Schreiben wird als Aktivität im Vorgang eingetragen. Makros <span className="font-mono">{"{{vorgang.number}}"}</span>, <span className="font-mono">{"{{letter.my_reference}}"}</span> stehen zur Verfügung.
                </div>
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
}
